import { API } from "./apiAuth";

// Function to get subscribe
const getLang = async () => { 
  try {
    const response = await API.get("member/language");
    return response.data;
  } catch (error) {
    console.error("Error get language", error);
    throw error;
  }
};


// Function to get subscribe
const getDashboard = async () => { 
  try {
    const response = await API.get("retri/dashboard");
    return response.data;
  } catch (error) {
    console.error("Error get dashboard", error);
    throw error;
  }
};

// Function to get recommend detail
const getRecommendDetail = async () => {
  try {
    const response = await API.get("retri/recommend-detail");
    return response.data;
  } catch (error) {
    console.error("Error get recommend detail", error);
    throw error;
  }
};

// Function to get subscribe
const getSubscribe = async () => {
  try {
    const response = await API.get("retri/subscribe");
    return response.data;
  } catch (error) {
    console.error("Error get subscribe", error);
    throw error;
  }
};

// Function to get weekly bonus histories
const getWeekHistories = async (page, language) => {
  try {
    const response = await API.get(`retri/bonus-history/weekly?page=${page}`, {
      headers: {
        "Accept-Language": language,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error get weekly bonus histories", error);
    throw error;
  }
};

// Function to get monthly bonus histories
const getMonthHistories = async (page, language) => {
  try {
    const response = await API.get(`retri/bonus-history/monthly?page=${page}`, {
      headers: {
        "Accept-Language": language,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error get monthly bonus histories", error);
    throw error;
  }
};

// Function to get daily bonus histories
const getDayHistories = async (page, language) => {
  try {
    const response = await API.get(`retri/bonus-history/daily?page=${page}`, {
      headers: {
        "Accept-Language": language,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error get daily bonus histories", error);
    throw error;
  }
};

export default {
  getLang,
  getDashboard,
  getRecommendDetail,
  getSubscribe,
  getWeekHistories,
  getMonthHistories,
  getDayHistories,
};
